import { lazy, ComponentType } from 'react';

export function lazyWithReload<T extends ComponentType<any>>(importFn: () => Promise<{ default: T }>) {
  return lazy(() =>
    importFn().catch(error => {
      if (
        error?.message?.includes('Failed to fetch dynamically imported module') ||
        error?.message?.includes('Loading chunk') ||
        error?.message?.includes('ChunkLoadError')
      ) {
        console.log('Chunk load error, reloading page...');
        window.location.reload();
      }
      throw error;
    })
  );
}
